import {WidgetConstants} from "../../utils/common";
import WorkItemTable from "../organisms/workItemsTable";
import React from "react";
import CodingQualitySettings from "../molecules/CodingQualitySettings";
import DefaultWrapper from "./DefaultWrapper";
import {WorkItemSettingsBtn} from "../atoms/buttons/WorkItemSettingsBtn";
import {Box} from "@mui/material";

interface IProps {
    client: any;
    widgetOptions: any;
    directoryType: string;
}

export default function CodingQuality(props: IProps) {
    const { client, widgetOptions, directoryType } = props;
    const [qaSettingsOpen, setQaSettingsOpen] = React.useState(false);
    const buttonAlt = "coding quality settings";
    if(!directoryType) return <></>;
    return (
        <DefaultWrapper>
            <Box sx={{
                flex: 1,
                minHeight: 0,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                width: '100%',
                height: '100%',
                padding: '2.5rem',
            }}>
                <WorkItemTable
                    DirectoryType={directoryType}

                    widgetType={WidgetConstants.QA}
                    widgetTitle={"Coding Quality"}
                    widgetTitleActions={(
                        <WorkItemSettingsBtn onClick={() => setQaSettingsOpen(true)} alt={buttonAlt}/>
                    )}

                    client={client}
                    handleRowClick={(workitem, data) => {
                        widgetOptions?.onWorkItemSelected(workitem, {
                            ...data,
                            isCodingQuality: true,
                        });
                    }}
                    handleViewWorkitemData={(workitem) => widgetOptions?.viewWorkitemData(workitem)}
                />
            </Box>

            <CodingQualitySettings isOpen={qaSettingsOpen} onClose={() => setQaSettingsOpen(false)} client={props.client} />
        </DefaultWrapper>
    );
}
